import React, { useState, useEffect, useMemo } from 'react';
import { history, useIntl, getLocale } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import Insights from './Insights/Page';
import Stats from './Stats/Page';
import { IEntityType, IGenreSource } from '../typings';
import { GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/GenreMarketProfile';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Body, Content } = Layout;

const Detailspage = () => {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [activeId, setActiveId] = useState('insights');
  const [entityType, setEntityType] = useState<IEntityType>('mobile');
  const [genreName, setGenreName] = useState('');
  const [genreNameCn, setGenreNameCn] = useState('');
  const [genreType, setGenreType] = useState('mainSub');
  const [source, setSource] = useState<IGenreSource>('iegg');

  const filterValidEntityType = (_entityType: IEntityType) => {
    if (['pc', 'console', 'mobile'].includes(_entityType)) {
      return _entityType;
    }
    return 'mobile';
  };

  const filterValidSource = (_source: IGenreSource) => {
    if (['iegg', 'annie'].includes(_source)) {
      return _source;
    }
    return 'iegg';
  };

  const tabs = [
    {
      id: 'insights',
      label: formatMessage({ id: 'dbi_insights' }),
      className: GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT2_HIGHLIGHT1,
      component: (
        <Insights
          pcGameSegmentClassName={GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT2}
          entityType={filterValidEntityType(entityType)}
          genreType={genreType}
          genreName={genreName}
          genreSource={filterValidSource(source)}
        />
      ),
    },
    {
      id: 'stats',
      label: formatMessage({ id: 'dbi_stats' }),
      className: GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT3_HIGHLIGHT2,
      component: (
        <Stats
          pcGameSegmentClassName={GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT3_HIGHLIGHT3}
          bySegmentClassName={GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT3}
          entityType={filterValidEntityType(entityType)}
          genreType={genreType}
          genreName={genreName}
          genreSource={filterValidSource(source)}
        />
      ),
    },
  ];

  const isPageOk = useMemo(() => {
    return entityType && genreType && genreName && source;
  }, [entityType, genreType, genreName, source]);

  const onActive = (tab: { id: any }) => {
    setActiveId(tab.id);
    history.replace(
      `/intelligence/genreProfile/${entityType}Games/detail/${tab.id}?entityType=${entityType}&genre=${genreName}&genreCn=${genreNameCn}&genreType=${genreType}&source=${source}`,
    );
  };

  const setPageParams = (_query: any) => {
    const { entityType, genre, genreType, source, genreCn } = _query || {};
    setEntityType(entityType);
    setGenreName(genre);
    setGenreNameCn(genreCn);
    setGenreType(genreType);
    setSource(source);
  };

  useEffect(() => {
    const { pathname } = history.location;
    const _activeTabId = pathname.slice(pathname.lastIndexOf('/') + 1);
    setActiveId(_activeTabId);
    setPageParams(history.location.query);
  }, [history.location.pathname]);

  return (
    <Layout className="dbi-genre-profile-details">
      <Body>
        <Content>
          <Content.Header
            className="contentHead-normal"
            showBackButton
            onBackButtonClick={() => history.goBack()}
            // onBackButtonClick={() => {history.replace(`/intelligence/genreProfile/${entityType}Games`);}}
            title={locale === 'zh-CN' ? genreNameCn || genreName : genreName}
          >
            <div className="header-tab">
              <Tabs
                ceiling
                newMarkIdsMappingKey="GenreProfileDetails"
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={onActive}
              />
            </div>
          </Content.Header>
          <Content.Body full>
            <MarqueeBanner />
            {isPageOk &&
              tabs.map((e) => {
                return <div key={e.id}>{e.id == activeId ? e.component : ''}</div>;
              })}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default Detailspage;
